var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppBarMyListWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5191 2H5.45038C4.06183 2 3 3.14351 3 4.53206V20.6229C3 21.6031 3.49008 22.4198 4.30687 22.9099C5.04198 23.3183 6.02214 23.3183 6.75725 22.8282L11.5763 19.7244C11.8214 19.5611 12.1481 19.5611 12.3931 19.7244L17.2122 22.8282C17.9473 23.3183 18.8458 23.3183 19.6626 22.9099C20.4794 22.4198 20.9695 21.6031 20.9695 20.6229V4.53206C20.9695 3.14351 19.9076 2 18.5191 2ZM19.3359 20.7046C19.3359 21.0313 19.1725 21.358 18.8458 21.5214C18.6008 21.6847 18.3557 21.6847 18.1107 21.5214L13.2916 18.3359C12.4748 17.8458 11.4947 17.8458 10.7595 18.3359L5.94046 21.4397C5.69542 21.6031 5.45038 21.6031 5.20534 21.4397C4.87863 21.2763 4.71527 20.9496 4.71527 20.6229V4.53206C4.63359 4.04198 4.96031 3.63359 5.45038 3.63359H18.5191C19.0092 3.63359 19.3359 4.04198 19.3359 4.53206V20.7046Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9858 7.63593H8.06289C7.57281 7.63593 7.24609 7.96264 7.24609 8.45272C7.24609 8.9428 7.57281 9.26951 8.06289 9.26951H15.9858C16.4759 9.26951 16.8026 8.9428 16.8026 8.45272C16.8026 7.96264 16.3942 7.63593 15.9858 7.63593Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9858 12.5367H8.06289C7.57281 12.5367 7.24609 12.8634 7.24609 13.3535C7.24609 13.8436 7.57281 14.1703 8.06289 14.1703H15.9858C16.4759 14.1703 16.8026 13.8436 16.8026 13.3535C16.8026 12.8634 16.3942 12.5367 15.9858 12.5367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppBarMyListWhite);
export default __webpack_public_path__ + "static/media/appBarMyListWhite.86de35d4c4dfb324e3c07d80fec94452.svg";
export { ForwardRef as ReactComponent };